import { createApp } from 'vue'
import locale from "element-plus/lib/locale/lang/zh-cn";
import App from './App.vue'
import router from './router'
import ElementPlus from "element-plus"
import 'element-plus/dist/index.css'
import api from './assets/api'

const app = createApp(App);

app.use(ElementPlus, {locale});
app.use(router).mount('#app');
app.config.globalProperties.$api = api;
app.directive('title', {
    insert: function (el) {
        document.title = el.dataset.title;
    }
});

router.beforeEach((to, from, next) => {
    window.document.title = "Tiandy 微信服务"
    if (to.matched.some(res => res.meta.requireAuth)) {
        if (sessionStorage.getItem('sid')) {
            if (to.path === '/userManage'){
                if(sessionStorage.getItem('sid')!=='admin'){
                    return next('/serviceIndex');
                }
            }
            next();
        } else {
            next({
                path: '/',
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});